const MEDIA = {
    mobile: "767px",
    tablet: "1024px",
    laptop: "1400px",
    desktop: "1920px",
};

const COLOR = {
    white: "#ffffff",
    black: "#000000",
    positive: {
        100: "#7bc333",
        200: "#608d33",
    },
    negative: "#8d3333",
    button: {
        100: "#fcf2e8",
        200: "#dd107f",
    },
    pagination: {
        100: "#f5f3ef",
        200: "#cac19f",
    },
    text: {
        100: "#f8f8f8",
        200: "#dcdcdc",
        300: "#cbcbcb",
        400: "#a8a8a8",
        500: "#6b6b6b",
        600: "#1f1f1f",
    },
    bgColor: {
        100: " #ecf7ff",
        200: "#a4c6df",
        300: "#3b6c8d",
    },
    none: "",
};

const theme = {
    MEDIA,
    COLOR,
};

export default theme;
